exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GIS_Client #mapstore-login-menu {\r\n    text-align: right;\r\n}\r\n", ""]);

// exports
